import { render } from "./AllPatients.vue?vue&type=template&id=3445c388&scoped=true"
import script from "./AllPatients.vue?vue&type=script&lang=js"
export * from "./AllPatients.vue?vue&type=script&lang=js"

import "./AllPatients.vue?vue&type=style&index=0&id=3445c388&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3445c388"]])

export default __exports__